export default {
  amazonAssociateEarnings: 'As an Amazon Associate, we earn from qualifying purchases.'
}
